"use client";

import { journalSchema } from "../../../lib/types/schema/journalSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyJournal } from "./keyJournals";

export type UseRequestJournalProps = UseRequestQueryProps & {
  id: number;
};

export const useRequestJournal = ({
  id,
  ...props
}: UseRequestJournalProps) => ({
  query: useRequestQuery<typeof journalSchema>({
    enabled: typeof id === "number",
    enabledWithoutSessionToken: false,
    queryFnRequestProps: {
      urlBackendPath: `/journals/${id}`,
      schema: journalSchema,
    },
    queryKey: keyJournal({ id }),
    ...props,
  }),
});
